const IS_DEV = import.meta.env.DEV;

const SENSITIVE = ["password", "token", "sessionid", "session_id", "authorization"];

function redactFields(fields) {
  if (!fields || typeof fields !== "object") return fields;
  const out = {};
  for (const [key, value] of Object.entries(fields)) {
    const lower = String(key).toLowerCase();
    if (SENSITIVE.some((s) => lower.includes(s))) {
      out[key] = "***";
    } else if (typeof value === "string" && value.length > 8 && lower.includes("token")) {
      out[key] = `${value.slice(0, 4)}***`;
    } else {
      out[key] = value;
    }
  }
  return out;
}

function emit(prefix, message, fields) {
  if (!IS_DEV) return;
  const safe = redactFields(fields);
  if (safe && Object.keys(safe).length) {
    console.info(prefix, message, safe);
  } else {
    console.info(prefix, message);
  }
}

export function corporateFeAuthTrace(message, fields) {
  emit("[CORPORATE_FE_AUTH_TRACE]", message, fields);
}

export function corporateFeRouteTrace(message, fields) {
  emit("[CORPORATE_FE_ROUTE_TRACE]", message, fields);
}

export function corporateOrdersTrace(message, fields) {
  emit("[CORPORATE_ORDERS_TRACE]", message, fields);
}

export function corporateSearchTrace(message, fields) {
  emit("[CORPORATE_SEARCH_TRACE]", message, fields);
}

export function corporatePriceDisplayTrace(message, fields) {
  emit("[CORPORATE_PRICE_DISPLAY_TRACE]", message, fields);
}

export function corporateResultsSanitizeTrace(message, fields) {
  emit("[CORPORATE_RESULTS_SANITIZE_TRACE]", message, fields);
}

export function corporateResultCardTrace(message, fields) {
  emit("[CORPORATE_RESULT_CARD_TRACE]", message, fields);
}

export function corporatePackagePageTrace(message, fields) {
  emit("[CORPORATE_PACKAGE_PAGE_TRACE]", message, fields);
}

export function corporatePackagePriceTrace(message, fields) {
  emit("[CORPORATE_PACKAGE_PRICE_TRACE]", message, fields);
}

/** Company package details / checkout — single price SSOT audit line. */
export function companyPackagePriceTrace(fields) {
  emit("[COMPANY_PACKAGE_PRICE_TRACE]", "price", fields);
}

/** Detects late overrides of locked package summary pricing (room selection / hydration). */
export function companyPackagePriceOverrideTrace(fields) {
  emit("[COMPANY_PACKAGE_PRICE_OVERRIDE_TRACE]", "override", fields);
}

/** Company room selection — board basis SSOT audit (agent parity). */
export function companyRoomBoardBasisTrace(fields) {
  emit("[COMPANY_ROOM_BOARD_BASIS_TRACE]", "board", fields);
}

/** Company room option / occupancy tab — supplier vs package price audit. */
export function companyRoomOptionPriceTrace(fields) {
  emit("[COMPANY_ROOM_OPTION_PRICE_TRACE]", "room price", fields);
}

/** Full findExtendedDeals rooms payload — API SSOT for corporate room selection. */
export function companyPackageApiRoomsTrace(fields) {
  emit("[COMPANY_PACKAGE_API_ROOMS_TRACE]", "api rooms", fields);
}

/** USD SSOT + ILS display helper audit (company portal). */
export function companyPriceDualCurrencyTrace(fields) {
  emit("[COMPANY_PRICE_DUAL_CURRENCY_TRACE]", "dual currency", fields);
}

export function corporatePackageFlightTrace(message, fields) {
  emit("[CORPORATE_PACKAGE_FLIGHT_TRACE]", message, fields);
}

export function corporateRoomSelectionTrace(message, fields) {
  emit("[CORPORATE_ROOM_SELECTION_TRACE]", message, fields);
}

export function corporateRoomPriceTrace(message, fields) {
  emit("[CORPORATE_ROOM_PRICE_TRACE]", message, fields);
}

export function corporateRoomOccupancyTrace(message, fields) {
  emit("[CORPORATE_ROOM_OCCUPANCY_TRACE]", message, fields);
}

export function corporateRoomOptionsTrace(message, fields) {
  emit("[CORPORATE_ROOM_OPTIONS_TRACE]", message, fields);
}

export function corporateRoomOptionsRawTrace(message, fields) {
  emit("[CORPORATE_ROOM_OPTIONS_RAW_TRACE]", message, fields);
}

export function corporatePackageDataKeysTrace(message, fields) {
  emit("[CORPORATE_PACKAGE_DATA_KEYS_TRACE]", message, fields);
}

export function corporateRoomSourceCompareTrace(message, fields) {
  emit("[CORPORATE_ROOM_SOURCE_COMPARE_TRACE]", message, fields);
}

export function corporateSupplierRateTrace(message, fields) {
  emit("[CORPORATE_SUPPLIER_RATE_TRACE]", message, fields);
}

/** Infant count validation — API maxInfants / infantFare SSOT. */
export function companyRoomInfantValidationTrace(fields) {
  emit("[COMPANY_ROOM_INFANT_VALIDATION_TRACE]", "infant validation", fields);
}

/** Navigation from company package page → checkout (frozen snapshot). */
export function companyCheckoutNavigationTrace(fields) {
  emit("[COMPANY_CHECKOUT_NAVIGATION_TRACE]", "checkout nav", fields);
}

/** Back from company package details → search results. */
export function companyPackageBackNavTrace(fields) {
  emit("[COMPANY_PACKAGE_BACK_NAV_TRACE]", "back nav", fields);
}
